import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import ExpandableContent from './ExpandableContent';

const rowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  '&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body': {
    py: '16px',
    borderBottom: '1px solid #F3F3F3',
  },
  cursor: 'pointer',
};

type DetailHistoryListType = {
  dataAnswers: any;
  handleRowClick: (log: any) => void;
};
const DetailHistoryList: React.FC<DetailHistoryListType> = (props) => {
  const [rowActive, setRowActive] = useState(0);

  const handleRowClick = (log: any, index: number) => {
    setRowActive(index);
    props.handleRowClick(log);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        width: '100%',
        height: '100%',
      }}
    >
      <Table
        sx={{
          // minWidth: 700,
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '1px solid #F3F3F3',
            fontWeight: 700,
            p: '6px',
            fontSize: '14px',
          },
          '& .MuiTableCell-root.MuiTableCell-body': {
            color: 'primary.dark',
            fontSize: '14px',
            py: '6px',
          },
        }}
        aria-label='simple table'
      >
        <TableHead>
          <TableRow>
            <TableCell width={'170px'}>日時</TableCell>
            <TableCell width={'95px'}>更新者</TableCell>
            <TableCell width={'95px'}>区分</TableCell>
            <TableCell width={'100px'}>バージョン</TableCell>
            <TableCell>変更</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.dataAnswers &&
            props.dataAnswers.map((log: any, index: number) => (
              <TableRow
                key={index}
                sx={{
                  ...rowStyle,
                  '&.MuiTableRow-root': {
                    backgroundColor: rowActive === index ? '#eee' : '',
                  },
                }}
                onClick={() => handleRowClick(log, index)}
              >
                <TableCell>{log.submitted_at}</TableCell>
                <TableCell>
                  {log.updated_by_name}
                </TableCell>
                <TableCell>
                  {log.is_updated_by_staff ? 'スタッフ' : '患者'}
                </TableCell>
                <TableCell>
                  {log.form_version}
                </TableCell>
                <TableCell sx={{ wordBreak: 'break-all' }}>
                  <ExpandableContent>
                    {Array.isArray(log.change_log) &&
                      log.change_log.map((change: any, index: number) => {
                        return (
                          <Stack
                            key={index}
                            sx={{ fontSize: '12px', mb: '4px' }}
                          >
                            {Array.isArray(change) && (
                              <>
                                {change[0].question}
                                <Stack direction={'row'} spacing={'12px'} alignItems={'center'}>
                                  <Typography>
                                    {change[0].old_value}{' '}
                                  </Typography>
                                  <Typography color={'#ED5565'}>
                                    {' '}
                                    → {change[0].new_value}
                                  </Typography>
                                </Stack>
                              </>
                            )}
                          </Stack>
                        );
                      })}
                  </ExpandableContent>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailHistoryList;
